// extracted by mini-css-extract-plugin
module.exports = {"checkBoxGroupContainer":"appointments__AdditionalAppointmentSlotTypeSelector__checkBoxGroupContainer","title":"appointments__AdditionalAppointmentSlotTypeSelector__title"};